var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueIndicatorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Switch-Inactive-Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit---Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Local/Switch/Inactive",
    fill: "#FFFFFF",
    stroke: "#252225"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Switch-Inactive-Shape",
    cx: 10,
    cy: 10,
    r: 9.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueIndicatorDefault);
export default __webpack_public_path__ + "static/media/value-indicator-default.c4c170d61505d78be03130644b405ade.svg";
export { ForwardRef as ReactComponent };